import React, { useState, useEffect } from "react";
import DeleteModal from "./Assets/DeleteModal";
import { TbEdit } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";
import { toast } from "react-toastify";

const Roles = ({ isSidebarCollapsed }) => {
  const [Roles, setRoles] = useState([]);
  const [formData, setFormData] = useState({
    
    role_name: "",
  });
  const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const Auth = localStorage.getItem("authToken");
    useEffect(() => {
    fetchRoles();
  }, []);
  
  const fetchRoles = async () => {
    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/get-data-list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch users");

      const result = await response.json();
      
      setRoles(result.roles || []);
      
      setLoading(false);
    } catch (err) {
      console.error("Error fetching roles:", err);
      setError(err.message);
      setLoading(false);
    }
  };


  if (loading) {
    return <h2 className="text-center">Loading...</h2>;
  }


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    let response;
    if (editId) {
      
      response = await fetch(`https://backend.sanchalansetu.com/api/v1/roles/edit/${editId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`,
        },
        body: JSON.stringify(formData),
      });
    } else {
      
      response = await fetch("https://backend.sanchalansetu.com/api/v1/roles/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`,
        },
        body: JSON.stringify(formData),
      });
    }
    
      const errorText = await response.json();
      if (!response.ok) {
        toast.error(errorText.message || "Failed to save designation");
      }else{
        toast.success(errorText.message || "Designation saved successfully!");
      }

    
    await fetchRoles();

    setFormData({ role_name: "" });
    setEditId(null);

  } catch (error) {
    console.error("Error saving designation:", error);
  }
};

  const handleEdit = (id) => {
    const roleToEdit = Roles.find((p) => p.id === id);
    if (roleToEdit) {
      setFormData({
        role_name: roleToEdit.role_name,
      });
      setEditId(id);
    }
  };

  const cancelEdit = () => {
    setFormData({ role_name: "" });
    setEditId(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    try {

      const response = await fetch(`https://backend.sanchalansetu.com/api/v1/roles/delete/${itemToDelete}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        }  
      });
      const errorText = await response.json();
      
      
      if (!response.ok) {
        toast.error(errorText.message || "Failed to delete Designation");
      }else{
        toast.success(errorText.message || "Designation deleted successfully");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    }
    fetchRoles(); 
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  return (
    <div className=" role-settings-container">
      
      <div className="bg-white p-[1vw]  role-settings-form-container">
        <div className="text-[20px] font-bold border-b-1 text-gray-600 border-gray-300 pb-[2px]">
          <h1 className="text-gray-600">
            {editId ? "Update Designation" : "Add Designation"}
          </h1>
        </div>
        <form className="bg-white pt-1 rounded-lg" onSubmit={handleSubmit}>
          
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Designation Name *
            </label>
            <input
              name="role_name"
              value={formData.role_name}
              onChange={handleInputChange}
              type="text"
              placeholder="Enter Role Name"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          

          <div className="flex items-center gap-2">
            <button
              type="submit"
              className="bg-blue-500 text-sm hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              {editId ? "Update" : "Save"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={cancelEdit}
                className="bg-gray-500 text-sm hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      
      <ul className="w-full role-settings-display-container">
        <li className="bg-white p-[1vw]">
          <div className="text-[20px] font-bold pb-[10px]">
            <h1>Designation List </h1>
          </div>
          <section className="flex flex-col justify-center">
            <div className="h-full">
              <div className="w-full bg-white">
                <div className="overflow-x-auto">
                  <table className="table-auto w-full">
                    <thead className="font-semibold uppercase text-white bg-blue-500">
                      <tr className="grid text-xs grid-cols-4">
                        
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-left">#</div>
                        </th>
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-left">Designation</div>
                        </th>
                        <th className="px-4 py-2 whitespace-nowrap">
                          <div className="font-semibold text-center">Action</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {Roles.length > 0 ? (
                        Roles.map((role, index) => (
                          <tr className="grid grid-cols-4" key={role.id}>
                            <td className="px-4 py-2 whitespace-nowrap">
                              <div
                                className={`text-left font-medium text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {index+1}
                              </div>
                            </td>


                            <td className="pr-4 py-2 whitespace-nowrap">
                              <div
                                className={`text-left text-gray-800 ${
                                  isSidebarCollapsed ? "text-base" : "text-sm"
                                }`}
                              >
                                {role.role_name || "N/A"}
                              </div>
                            </td>

                            
                            <td className="px-4 py-2 whitespace-nowrap">
                              <div className="flex gap-2 justify-center items-center">
                                <button
                                  onClick={() => handleEdit(role.id)}
                                  className={`text-blue-500 hover:text-blue-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Edit"
                                >
                                  <TbEdit />
                                </button>
                                <button
                                  onClick={() => handleDeleteClick(role.id)}
                                  className={`text-red-500 hover:text-red-700 ${
                                    isSidebarCollapsed ? "text-[16px]" : "text-[20px]"
                                  }`}
                                  title="Delete"
                                >
                                  <MdDeleteOutline />
                                </button>
                              </div>
                            </td>
                          </tr>

                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="p-2 text-center">
                            No Coin Details added yet
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </li>
        
      </ul>

      
      {deleteModalShow && (
        <DeleteModal
          itemName={Roles.find((p) => p.id === itemToDelete)?.role_name || "Role"}
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
    </div>
  );
};

export default Roles;
